import { IconCard, IconCardProps } from '../IconCard/IconCard';

interface IconCardRowProps {
  items: IconCardProps[];
}

const IconCardRow = ({ items = [] }: IconCardRowProps) => {
  return (
    <div className={`grid grid-cols-1 gap-4 sm:gap-6 md:grid-cols-2 lg:grid-cols-${items.length}`}>
      {items && items.map((item, i) => <IconCard key={i} {...item} />)}
    </div>
  );
};

export default IconCardRow;
